/* Defer a Swiper init until its container nears the viewport (300px margin).
   Falls back to immediate init when IntersectionObserver is unavailable. */
function initNearView(el, init) {
  if (!el) return;
  if (!('IntersectionObserver' in window)) { init(); return; }
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { io.disconnect(); init(); }
  }, { rootMargin: '300px 0px' });
  io.observe(el);
}

jQuery(document).ready(function () {


  // Product info
  var $info = $('.fon-product-info');
  var $gallery = $('#onefit-all-gallery');
  var $defaultPlace = $('.fon-product-info-placement');

  // Function to move the element based on window width
  function moveInfo() {
      var width = $(window).width();
      if (width <= 768) { // Mobile breakpoint
          if (!$info.prev().is($gallery)) {
              $info.insertBefore($gallery);
              $info.hide().show(); // smooth transition
          }
      } else { // Desktop
          if (!$info.prev().is($defaultPlace)) {
              $info.insertAfter($defaultPlace);
              $info.hide().show(); // smooth transition
          }
      }
  }

  // Initial check
  moveInfo();
  movedStatus = false;

  // // On window resize
  // $(window).resize(function() {
  //   if (!movedStatus)
  //     moveInfo();
  // });


  // Accordion
  $('.fon-accordion-container .fon-accordion').first().addClass('active');
  $('.fon-accordion-container .fon-accordion').first().find('.content').slideDown();


  $(document).on('click','.fon-accordion-container .fon-accordion .title',function(){

      var parent = $(this).parents('.fon-accordion');


      $('.fon-accordion-container .fon-accordion').not(parent).removeClass('active');
      $('.fon-accordion-container .fon-accordion').not(parent).find('.content').slideUp();

      if (parent.hasClass('active')){
        parent.removeClass('active');
        parent.find('.content').slideUp();
      }else{
        parent.addClass('active');
       parent.find('.content').slideDown();
      }
      

  });


  $(document).on('click','.for-me-front',function(e){

    var parent = $(this).parents('.for-me');

    $('.for-me').not(parent).removeClass('is-flipped');
    $('.for-me-accordion').removeClass('active');
    $('.for-me-accordion .for-me-content').slideUp();

    parent.addClass('is-flipped');
    
  });



  $(document).on('click','.for-me-accordion .for-me-action',function(e){

    var accordionParent = $(this).parents('.for-me-accordion');

    $('.for-me-accordion').not(accordionParent).removeClass('active');
    $('.for-me-accordion').not(accordionParent).find('.for-me-content').slideUp();

    
    
    if ($(this).parents('.for-me-accordion').hasClass('active')){
      $(this).parents('.for-me-accordion').find('.for-me-content').slideUp();
      $(this).parents('.for-me-accordion').removeClass('active')
    }else{
      $(this).parents('.for-me-accordion').find('.for-me-content').slideDown();
      $(this).parents('.for-me-accordion').addClass('active')
    }

  });

  // click OUTSIDE
  $(document).on('click', function (e) {
      // if (!$(e.target).closest('.for-me-accordion .for-me-action').length) {
      //     $('.for-me-accordion').removeClass('active');
      //     $('.for-me-accordion .for-me-content').slideUp();
      // }
      
      console.log(e.target);


      if ($(e.target).hasClass('for-me-action')) {
        
      }else{

        if ($(e.target).parents('.for-me-back').length) {
          
            $('.for-me-accordion').removeClass('active');
            $('.for-me-accordion .for-me-content').slideUp();
            $(e.target).parents('.for-me-back').parents('.for-me').removeClass('is-flipped');
        }else{
          $('.for-me-accordion').removeClass('active');
          $('.for-me-accordion .for-me-content').slideUp();
        }
        

      }

  
      //  if (!$(e.target).closest('.for-me-accordion .for-me-action').length || $(e.target).closest('.for-me-front').length) {
      //     $('.for-me-accordion').removeClass('active');
      //     $('.for-me-accordion .for-me-content').slideUp();
      //     $('.for-me.is-flipped').removeClass('is-flipped');
      // }
  });


  $(document).on('click','.option-popup .expand',function(){
    var parent = $(this).parents('.option-popup');

    if (!$(this).hasClass('active')){
      $(this).addClass('active');
      parent.find('.expand-content').show();
    }else{
      $(this).removeClass('active');
      parent.find('.expand-content').hide();
    }
    
  });


  $(document).on('mouseover','.of-expectation',function(){
    var index = $(this).data('index');
    $('.expection-nav > div').removeClass('active-index');
    $('.expection-nav > div[data-index="'+index+'"]').addClass('active-index');
  });
  $(document).on('mouseout','.of-expectation',function(){
    $('.expection-nav > div').removeClass('active-index');
  });

//   $(".main-gallery video[autoplay]").each(function() {
//     var video = this;
//     var playPromise = video.play();

//     if (playPromise !== undefined) {
//       playPromise.catch(function() {
//         // Autoplay blocked → play on first tap
//         $(document).one("touchstart", function() {
//           video.play();
//         });
//       });
//     }
//   });

//   /*
//   * Name: Hide the subscription widget based from customer's ip address country location
//   * Fallback: Shopify market geo redirect
//   */
//   // $(window).on('load', function () {
//   //   $('body').removeClass('body-non-au');
  
//   //   const apiKey = '6be9e5e33b3f9ee33ee7ebd401a82a65472dc1f1';
//   //   const geoApiUrl = `https://api.getgeoapi.com/v2/ip/check?api_key=${apiKey}&format=json`;
//   //   const allowedCountries = ['AU','NZ','PH'];
//   //   const storageKey = 'user_country_code';
//   //   const expiryKey = 'user_country_code_expiry';
//   //   const ttlHours = 4;
  
//   //   function applySubscriptionChanges() {
//   //     $('body').addClass('body-non-au');
//   //     $('#fon-onetime-option').trigger('click');
//   //     $('#fon-subscription-options,.fon-subscription-option-seperator').hide();
//   //   }
  
//   //   function handleCountry(countryCode) {
//   //     console.log(`[handleCountry] Country code is "${countryCode}".`);
//   //     if (!allowedCountries.includes(countryCode)) {
//   //       console.log(`[handleCountry] "${countryCode}" is NOT allowed. Applying changes.`);
//   //       applySubscriptionChanges();
//   //     } else {
//   //       console.log(`[handleCountry] "${countryCode}" is allowed (AU or PH). No changes needed.`);
//   //     }
//   //   }
  
//   //   function isExpired() {
//   //     const expiry = localStorage.getItem(expiryKey);
//   //     const now = Date.now();
//   //     if (!expiry) {
//   //       console.log('[isExpired] No expiry found in localStorage.');
//   //       return true;
//   //     }
//   //     const isExpired = now > parseInt(expiry, 10);
//   //     console.log(`[isExpired] Now: ${now}, Expiry: ${expiry}, Expired: ${isExpired}`);
//   //     return isExpired;
//   //   }
  
//   //   function saveCountryToStorage(countryCode) {
//   //     const expiryTime = Date.now() + ttlHours * 60 * 60 * 1000;
//   //     localStorage.setItem(storageKey, countryCode);
//   //     localStorage.setItem(expiryKey, expiryTime.toString());
//   //     console.log(`[saveCountryToStorage] Stored "${countryCode}" with expiry at ${new Date(expiryTime).toLocaleString()}`);
//   //   }
  
//   //   function fetchAndStoreCountry() {
//   //     console.log('[fetchAndStoreCountry] Fetching country via GeoAPI...');
//   //     $.getJSON(geoApiUrl)
//   //       .done(function (data) {
//   //         let countryCode = null;
  
//   //         if (data.status === 'success' && data.country && data.country.code) {
//   //           countryCode = data.country.code;
//   //           console.log(`[GeoAPI] Success: Country code from API: "${countryCode}"`);
//   //         } else if (typeof Shopify !== 'undefined' && Shopify.country) {
//   //           countryCode = Shopify.country;
//   //           console.log(`[GeoAPI] Failed. Fallback to Shopify.country: "${countryCode}"`);
//   //         } else {
//   //           console.log('[GeoAPI] No country code found.');
//   //         }
  
//   //         if (countryCode) {
//   //           saveCountryToStorage(countryCode);
//   //           handleCountry(countryCode);
//   //         }
//   //       })
//   //       .fail(function () {
//   //         console.warn('[GeoAPI] API call failed.');
//   //         if (typeof Shopify !== 'undefined' && Shopify.country) {
//   //           const fallbackCountry = Shopify.country;
//   //           console.log(`[GeoAPI] Fallback to Shopify.country: "${fallbackCountry}"`);
//   //           saveCountryToStorage(fallbackCountry);
//   //           handleCountry(fallbackCountry);
//   //         } else {
//   //           console.warn('[GeoAPI] No fallback available.');
//   //         }
//   //       });
//   //   }
  
//   //   const storedCountry = localStorage.getItem(storageKey);
  
//   //   if (storedCountry && !isExpired()) {
//   //     console.log(`[LocalStorage] Found valid country: "${storedCountry}".`);
//   //     handleCountry(storedCountry);
//   //   } else if (storedCountry && isExpired()) {
//   //     console.log('[LocalStorage] Expired data. Fetching new data...');
//   //     fetchAndStoreCountry();
//   //   } else {
//   //     console.log('[LocalStorage] No data found. Fetching...');
//   //     fetchAndStoreCountry();
//   //   }
//   // });




//   $(window).on("scroll", function() {
//     var checkoutBtn = $("#fon-checkout-button");

//     if (checkoutBtn.length) {
//       var scrollTop = $(window).scrollTop();
//       var checkoutOffset = checkoutBtn.offset().top;

//       if (scrollTop > checkoutOffset) {
//         $("body").addClass("scrolled-add-to-cart");
//       } else {
//         $("body").removeClass("scrolled-add-to-cart");
//       }
//     }
//   });


//   if ($(window).outerWidth() >= 768){
//     $('#onefit-all-gallery').stickySidebar({
//         topSpacing: 110,
//         bottomSpacing: 60
//     });
//   }


//   let mainSwiper;

//   function initSwiper() {
//     if (window.innerWidth >= 300 && !mainSwiper) {
//       mainSwiper = new Swiper(".main-gallery", {
//         // zoom: true,
//         // touchStartPreventDefault: false,
//         loop: false,
//          navigation: {
//           nextEl: ".swiper-button-next",
//           prevEl: ".swiper-button-prev",
//         },
//         spaceBetween: 10,
//         // navigation: false, // default: hidden on desktop
//         pagination: {
//           el: ".swiper-pagination",
//           clickable: true,
//         },
//       });


//       // Thumbnail click navigation
//       const $thumbs = $(".thumb");
//       $thumbs.each(function (index) {
//         $(this).on("click", function () {
//           mainSwiper.slideToLoop(index);
//         });
//       });

//         // Initial active thumb
//         setActiveThumb(mainSwiper);

//         // Update active thumb on slide change
//         mainSwiper.on("slideChange", function () {
//           setActiveThumb(mainSwiper);
//         });
        

//       // Sync active thumbnail
//       function setActiveThumb(swiper) {
//         $thumbs.removeClass("active");
//         if (swiper && swiper.realIndex){
//           const realIndex = swiper.realIndex;
//           $thumbs.eq(realIndex).addClass("active");
//         }
//       }

//     } else if (window.innerWidth < 788 && mainSwiper) {
//       // Destroy if going back to mobile
//       mainSwiper.destroy(true, true);
//       mainSwiper = null;
//     }
//   }

//   // Run on load
//   initSwiper();

//   // Run on resize
//   // window.addEventListener("load", initSwiper);





//  // Flavour options
 

//   $(document).on('click','#fon-oos-button',function(){

//       var variantID = $('.fon-flavour.active').attr('data-variant-id');
//       $.magnificPopup.open({
//         items: {
//           src: '.klaviyo-oos-' + variantID // This is the ID of the hidden div
//         },
//         type: 'inline'
//       });

//   });


//   var flavourClick  = 0;
//   // $(".flavour-options > div").not(".fon-flavour-oos").on("click", function () {
//   $(".flavour-options > div").on("click", function () {

    
//     if ($(this).hasClass('fon-flavour-oos')){
//       $('body').addClass('selected-variant-oos');
//       $('#fon-oos-button').addClass('active');
//     }else{
//       $('body').removeClass('selected-variant-oos');
//       $('#fon-oos-button').removeClass('active');
//     }

//     flavourClick++;

//     // Reset siblings
//     $(this).siblings()
//       .removeClass("active");

//     // Activate this one
//     $(this)
//     .addClass("active")
//     .find(".flavour-color")
//     .css({
//       "background-color": $(this).data("color"),
//       "border-color": $(this).data("color")
//     });
    
//     // if (isLightColor($(this).data("color"))) {
//     //   $(this).addClass("light");
//     // }

//     var selectedVariantText = $('.fon-flavour.active').attr('data-text');

//     selectedVariantText = '<div class=&quot;metafield-rich_text_field&quot;><p>Taste is personal. Hate it? Instant swap.</p></div>';
//     $('.flavour-label').html(selectedVariantText);


//     // Product Gallery
//     if (flavourClick > 1){
//       updateImage();
//     }
    

//     checkSelections();
//   });


//   function updateImage(){
//       var selectedVariantID = $('.fon-flavour.active').attr('data-variant-id');
//       var selectedVariantImage = $('.fon-flavour.active').attr('data-variant-image');
//       var selectedVariantVideo = $('.fon-flavour.active').attr('data-variant-video');
//       var selectedVariantImageMobile = $('.fon-flavour.active').attr('data-variant-image-mobile');
      
//       var size = parseInt($('[data-size]').data('size'));


//       // Cache the active element
//       var $active = $('.fon-flavour.active');

   
//       for (var i = 0; i < size; i++) {
//         var attrName = 'data-gallery-image-' + i;
//         var imageURL = $active.attr(attrName);

//         console.log(attrName + ' ' + imageURL);

//         if (imageURL) {
//           // Update thumbnail image
//           $('.thumb-index-' + i).find('img').attr('src', imageURL);

//           // Update main swiper slide image
//           $('.swiper-slide-fon-index-' + i).find('img').attr('src', imageURL);
//         }
//       }
      

//       // var selectedVariantSecondaryImage = $('.fon-flavour.active').attr('data-variant-secondary-image-desktop');
//       // var selectedVariantSecondaryImageMobile = $('.fon-flavour.active').attr('data-variant-secondary-image-mobile');


//       // var selectedVariantSubscriptionImage = $('.fon-flavour.active').attr('data-variant-subscription-image');
//       // var selectedVariantSubscriptionImageMobile = $('.fon-flavour.active').attr('data-variant-subscription-image-mobile');

//       // // alert(selectedVariantSecondaryImage);

//       // if ($('#fon-subscription-options').hasClass('active') && selectedVariantSubscriptionImage){
//       //   $('.thumb-first img').attr('src',selectedVariantSubscriptionImage);
//       //   $('.swiper-slide-first .slide-video-image').html(`
//       //       <picture>
//       //         <source media="(max-width: 767px)" srcset="${selectedVariantSubscriptionImageMobile}">
//       //         <img src="${selectedVariantSubscriptionImage}" class="img-fluid" alt="OneFit">
//       //       </picture>
//       //   `);
//       // }else{
//       //   $('.thumb-first img').attr('src',selectedVariantImage);
//       //   $('.swiper-slide-first .slide-video-image').html(`
//       //       <picture>
//       //         <source media="(max-width: 767px)" srcset="${selectedVariantImageMobile}">
//       //         <img src="${selectedVariantImage}" class="img-fluid" alt="OneFit">
//       //       </picture>
//       //   `);
//       // }
      
//       // $('.swiper-slide-secondary .slide-video-image').html(`
//       //     <picture>
//       //       <source media="(max-width: 767px)" srcset="${selectedVariantSecondaryImageMobile}">
//       //       <img src="${selectedVariantSecondaryImage}" class="img-fluid" alt="OneFit">
//       //     </picture>
//       // `);


//     }

   
  
//   // var defaultSKU = localStorage.getItem('default_sku');
//   // var defaultSKUStatus = false;
//   // if (defaultSKU){
//   //   if ($('.fon-flavour[data-flavour-sku="'+defaultSKU+'"]').length){
//   //     $('.fon-flavour[data-flavour-sku="'+defaultSKU+'"]').trigger('click');
//   //     defaultSKUStatus = true;
//   //     checkSelections();
//   //   }
//   // }

//   // if (!defaultSKUStatus){
//     // var firstAvailable = $(".flavour-options.active > .fon-flavour").not(".fon-flavour-oos").first();
//     // if (firstAvailable.length) {
//     //   firstAvailable.click();
//     //   checkSelections();
//     // }
//   // }

//   var selectedOrFirstAvailableVariantID = $('.flavour-options').attr('data-active-variant');
//   $(`.fon-flavour[data-variant-id="${selectedOrFirstAvailableVariantID}"]`).click();
//   checkSelections();

 

//   // Packaging options
//   $("#packaging-options .fon-packaging").on("click", function () {


    
//     $("#packaging-options .fon-packaging").removeClass("active");
//     $(this).addClass("active");

//     // Hide all flavour option groups
//     // Hide all flavour option groups
// $(".flavour-options").removeClass("active")
//   .find("div").removeClass("active")
//   .css("background-color", "inherit")           // reset parent div

//     // Show the matching flavour options
//     const packaging = $(this).data("packaging");
//     $(`#flavour-options-${packaging}`).addClass("active");
    
//     checkSelections();

//   });

//   // Quantity picker
//   $("#quantity-options > div").on("click", function () {
//     $(this).siblings().removeClass("active");
//     $(this).addClass("active");
//     checkSelections();
//   });

//   // Paying options
//   $("#paying-options > div").on("click", function () {
//     $(this).siblings().removeClass("active");
//     $(this).addClass("active");
//     checkSelections();
//   });


//   checkSelections();

//   function checkSelections(){
//       checkVariantOption();
//       checkPrices();
//       checkCheckout();
//       checkAfterPay();

//       // Floating add to cart
//       var originalPrice = $('#fon-subscription-options').find('.original-price').html();
//       var salePrice = $('#fon-subscription-options').find('.sale-price').html();

//       $('.onefit-all-subscribe-save .save-new-price .price').html(salePrice);
//       $('.onefit-all-subscribe-save .save-old-price .price').html(originalPrice);
//       $('.onefit-all-onetime-only .save-new-price .price').html(originalPrice);

//       if ($('#fon-subscription-options').hasClass('active')){
//         $('.onefit-all-subscribe-save').show();
//         $('.onefit-all-onetime-only').hide();
//       }else{
//         $('.onefit-all-subscribe-save').hide();
//         $('.onefit-all-onetime-only').show();
//       }


//       $('.dynamic-selected-flavour').html($('.fon-flavour.active').attr('data-variant-title'));
//       $('.dynamic-selected-quantity').html($('.fon-quantity-picker.active').find('p').html());
      

//       if ($('div#fon-subscription-options').hasClass('active')){
//         $('.dynamic-selected-price').html('Subscription');
//       }else{
//         $('.dynamic-selected-price').html('One-time');
//       }

//   }

//   function checkAfterPay(){

//       var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');
//       if (activePaymentPlan == 'subscription'){
//         $('.afterpay-text').hide();
//       }else{
//         $('.afterpay-text').show();
//       }

//   }
//   function checkCheckout(){
//     var checkoutButton = $('#fon-checkout-button');
//     if ($('.fon-quantity-picker.active').length && $('.flavour-options > div.active').length){
//       checkoutButton.prop('disabled',false);
//     }else{
//       checkoutButton.prop('disabled',true);
//     }
//   }

//   $(document).on('click', '#fon-checkout-button, .btn-floating-add-to-cart', function () {
//     var $btn = $(this);

//     // Collect selected values
//     var quantityElement = $('.fon-quantity-picker.active');
//     var qty = parseInt(quantityElement.attr('data-qty'));

//     var selectedVariant = $('.flavour-options > div.active');
//     var variantID = selectedVariant.attr('data-variant-id');
//     var variantSellingPlanID = selectedVariant.attr('data-selling-plan-id');

//     var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');

//     // Prepare data for Shopify AJAX API
//     var formData = {
//       items: [
//         {
//           id: variantID,
//           quantity: qty
//         }
//       ]
//     };

//     if (activePaymentPlan === 'subscription' && variantSellingPlanID) {
//       formData.items[0].selling_plan = variantSellingPlanID;
//     }

//     // Disable button & show loading state
//     var originalText = $btn.text();
//     $btn.text('Adding...').prop('disabled', true);

//     // AJAX add to cart
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: JSON.stringify(formData),
//       dataType: 'json',
//       contentType: 'application/json',
//       success: function (response) {
//         console.log('Added to cart:', response);

//         // ✅ Update and open cart drawer
//         if (typeof FonCartDrawer !== 'undefined') {
//           FonCartDrawer.updateCartDrawer();
//           FonCartDrawer.openCartDrawer();
//         }

//         // ✅ Revert button
//         $btn.text(originalText).prop('disabled', false);
//       },
//       error: function (xhr, status, error) {
//         console.error('Error:', error);

//         // ❌ Revert button
//         $btn.text(originalText).prop('disabled', false);
//         alert('Something went wrong. Please try again.');
//       }
//     });
//   });


//   function checkPrices(){
//     if ($('.fon-quantity-picker.active').length && $('.flavour-options > div.active').length){

//       var selectedVariant = $('.flavour-options > div.active');
//       var onetimePrice = selectedVariant.attr("data-one-time-price");
//       var subscriptionPrice = selectedVariant.attr("data-subscription-price");

//       onetimePrice = onetimePrice / 100;
//       subscriptionPrice = subscriptionPrice / 100;
      

//       var quantityElement = $('.fon-quantity-picker.active');
//       var qty = parseInt(quantityElement.attr('data-qty'));





      

//       switch (qty){
//         case 1:

//           $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
//           $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
//           $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));

          

//         break;
//         case 2:
          
//           onetimePrice = onetimePrice * qty * .95;
//           subscriptionPrice = subscriptionPrice * qty * .95;

//           $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
//           $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
//           $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));


//         break;

//         case 3:
          
//           onetimePrice = onetimePrice * qty * .90;
//           subscriptionPrice = subscriptionPrice * qty * .90;

//           $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
//           $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
//           $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));


//         break;


//         case 4:

//           onetimePrice = onetimePrice * qty * .85;
//           subscriptionPrice = subscriptionPrice * qty * .85;
          
//           $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
//           $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
//           $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));

//         break;
//       }

//       var savePrice = onetimePrice - subscriptionPrice;
//       $('save-price').html(savePrice.toFixed(0));

//       var perServeValue = subscriptionPrice / (20 * qty);
//       $('.per-serve').html('$'+perServeValue.toFixed(2));

      
//     }
//   }
//   function checkVariantOption(){

    
//     if ($('.flavour-options > div.active').length){
//       var activeSelection = $('.flavour-options > div.active');

//       var onetimePrice = activeSelection.attr("data-one-time-price");
//       var subscriptionPrice = activeSelection.attr("data-subscription-price");

//       var priceBasis = onetimePrice / 100;


//       var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');
//       if (activePaymentPlan == 'subscription'){
//         priceBasis = subscriptionPrice / 100;
//       }
      

//       var serveBasis = 20;

//       if ($('.quantity-options-onelife').length){
//         serveBasis = 30;
//       }
      
//       $(".fon-quantity-picker").each(function(index, element) {
//         var qty = parseInt($(this).attr('data-qty'), 10);
//         var perServeElement = $(this).find('.value');
//         var perServeValue = 0;


//         switch (qty){
//           case 1:
//             perServeValue = priceBasis / serveBasis;
//           break;
//           case 2:
//             perServeValue = (priceBasis * qty * 0.95) / (serveBasis * qty);
//           break;
//           case 3:
//             perServeValue = (priceBasis * qty * 0.90) / (serveBasis * qty);
//           break;
//           case 4:
//             perServeValue = (priceBasis * qty * 0.85) / (serveBasis * qty);
//           break;
//         }

//         perServeElement.html(perServeValue.toFixed(2));
        
//       });

//       updateImage();

//     }

//   }


//   $(document).on('click', '.fon-accordion-heading', function () {
//     // Remove active from all others
//     $('.fon-accordion-heading').not(this).removeClass('active');

//     // Toggle only the clicked one
//     $(this).toggleClass('active');

//     // Smooth scroll to the clicked heading
//     $('html, body').animate({
//       scrollTop: $(this).offset().top - 100 // adjust offset for sticky headers, etc.
//     }, 400); // 400ms = smooth animation duration
//   });


//   var swiper = new Swiper(".reviews-swiper", {
//     slidesPerView: 1, // default for desktop
//     spaceBetween: 20,
//     grabCursor: true,
//     loop: true,
//     centeredSlides: true, // turned off grid-style center mode
//     breakpoints: {
//       // when window width is <= 768px (tablet & below)
//       768: {
//         slidesPerView: 3
//       }
//     }
//   });

//   var swiperHallOfFame = new Swiper(".swiper-of-all-hall", {
//     slidesPerView: 1.2,
//     spaceBetween: 42,
//     loop: true,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//     breakpoints: {
//       768: {
//         slidesPerView: 3,
//       },
//       992: {
//         slidesPerView: 4,
//         spaceBetween: 42
//       }
//     }
//   });
//   var swiperHallOfFame = new Swiper(".swiper-of-all-hall-mobile", {
//     slidesPerView: 1,
//     loop: true,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     }
//   });

//   // $('.open-supplement-facts').magnificPopup({
//   //   type: 'inline',
//   //   midClick: true, // allow opening popup on middle mouse click
//   //   closeBtnInside: true,
//   //   removalDelay: 300,
//   //   mainClass: 'mfp-fade'
//   // });

//   $('.open-supplement-facts').magnificPopup({
//     type: 'inline',
//     callbacks: {
//           open: function() {
//               console.log('Popup body-inline-bottom');
//               $('body').addClass('body-popup-slide');
//           },
//           close: function() {
//               console.log('Popup closed');
//               $('body').removeClass('body-popup-slide');
//           }
//     },
//     mainClass: 'mfp-animate-bottom',
//     closeMarkup: `
//       <button title="%title%" type="button" class="mfp-close">
//         <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
//           <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
//         </svg>
//       </button>
//     `
//   });


//   // Supplement Facts
//   $(document).on("click", ".flavour-options-facts > div", function() {
//     // remove active from siblings, add to clicked one
//     $(this).addClass("active").siblings().removeClass("active");

//     // check if clicked has .flavour-vegan
//     if ($(this).hasClass("flavour-vegan")) {
//       $(".protein-type").text("Pea Protein");
//     } else {
//       $(".protein-type").text("Organic Collagen Peptides");
//     }
//   });


  

//   // Helper: check if color is light
//   function isLightColor(hex) {
//     if (!hex) return false;
//     hex = hex.replace("#", "");

//     // Expand shorthand (e.g. "fff" → "ffffff")
//     if (hex.length === 3) {
//       hex = hex.split("").map(c => c + c).join("");
//     }

//     var r = parseInt(hex.substr(0, 2), 16);
//     var g = parseInt(hex.substr(2, 2), 16);
//     var b = parseInt(hex.substr(4, 2), 16);

//     // Perceived brightness (HSP)
//     var brightness = Math.sqrt(
//       0.299 * (r * r) +
//       0.587 * (g * g) +
//       0.114 * (b * b)
//     );

//     return brightness > 200; // threshold, tweak if needed
//   }



//   function initGallery($gallery) {
//   $gallery.on('click', 'img, video', function (e) {
//     e.preventDefault();

//     var $clicked = $(this);
//     var $items = $gallery.find('img, video');

//     var promises = $items.map(function () {
//       var $el = $(this);

//       // VIDEO ITEM
//       if ($el.is('video')) {
//         return Promise.resolve({
//           html:
//             '<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;">' +
//               '<video autoplay muted loop playsinline preload="auto" ' +
//               'style="max-width:100%;max-height:100%;width:auto;height:auto;">' +
//                 '<source src="' + $el.find('source').attr('src') + '" type="video/mp4">' +
//                 'Your browser does not support the video tag.' +
//               '</video>' +
//             '</div>',
//           w: 1920,
//           h: 1080
//         });
//       }

//       // IMAGE ITEM (get original size)
//       // <picture> carries no src — only its inner <img> does. Without this fallback
//       // imgSrc is undefined, the browser requests /products/undefined (404), img.onload
//       // never fires, Promise.all never settles and the lightbox never opens.
//       var imgSrc = $el.data('large') || $el.attr('src') || $el.find('img').attr('src');
//       return new Promise(function (resolve) {
//         var img = new Image();
//         img.onload = function () {
//           resolve({
//             src: imgSrc,
//             w: img.naturalWidth,
//             h: img.naturalHeight
//           });
//         };
//         img.src = imgSrc;
//       });
//     }).get();

//     Promise.all(promises).then(function (items) {
//       var index = $items.index($clicked);
//       var pswpElement = document.querySelector('.pswp');

//       var options = {
//         index: index,
//         bgOpacity: 0.9,
//         showHideOpacity: true,
//         barsSize: { top:44, bottom:'auto' }, // space for top bar
//         shareEl: false,                       // hide share if not needed
//         fullscreenEl: false,                  // hide fullscreen if not needed
//         zoomEl: false,                        // hide zoom if not needed
//         counterEl: false,                     // hide counter if not needed
//         arrowEl: true,                        // keep prev/next arrows
//         closeEl: true,                        // ✅ show close button
//         closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'] // where it should render
//       };

//       var lightbox = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
//       lightbox.init();
//     });
//   });
// }


//   // Desktop gallery
//   initGallery($('.product-main-gallery'));

//   const marqueeSwiper = new Swiper(".onefit-all-marquee-swiper", {
//     slidesPerView: "auto",   // size slides to content
//     spaceBetween: 30,        // spacing between
//     loop: true,              // seamless repeat
//     allowTouchMove: false,   // disable dragging
//     speed: 10000,            // how long 1 loop takes (ms) → higher = slower
//     autoplay: {
//       delay: 0,              // no pause, continuous
//       disableOnInteraction: false,
//     },
//   });

//   // $('.fon-flavour-oos').on('click', function () {
//   //   let $el = $(this);
//   //   $el.addClass('wiggle');
    
//   //   // remove after animation ends so it can trigger again
//   //   setTimeout(() => {
//   //     $el.removeClass('wiggle');
//   //   }, 500); // match animation duration
//   // });


//   // All videos
//   const videos = document.querySelectorAll('.onefit-all-videos video');

//   // Intersection Observer to trigger play when visible
//   let observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       const video = entry.target;

//       if (entry.isIntersecting) {
//         // Try autoplay unmuted
//         video.muted = true;
//         video.loop = true;
//         video.play().catch(err => {
//           console.log("Autoplay blocked:", err);
//         });

//         $('.onefit-all-videos img').fadeOut();
//         $('.onefit-all-videos video-media').attr('loaded','true');

//       } else {
//         video.pause(); // optional: pause when out of view
//       }
//     });
//   }, {
//     threshold: 0.1 // at least 50% visible
//   });

//   videos.forEach(video => observer.observe(video));

//   $('.onefit-all-videos .video-container').on('click', function () {
//     const $container = $(this);
//     const $video = $container.find('video').get(0);
//     const $overlay = $container.find('.video-overlay');

//     if ($video.muted) {
//       // Mute all others and reset overlays
//       $('.onefit-all-videos .video-container').each(function () {
//         const v = $(this).find('video').get(0);
//         v.muted = true;
//         $(this).find('.video-overlay').show();
//       });

//       // Unmute clicked video + hide overlay
//       $video.muted = false;
//       $overlay.hide();

//       if ($video.paused) {
//         $video.play().catch(() => {});
//       }
//     } else {
//       // Already unmuted → mute and show overlay
//       $video.muted = true;
//       $overlay.show();
//     }
//   });

//   const addToCartSwiper = new Swiper('.swiper-add-to-cart-carousel', {
//     effect: 'fade',
//     fadeEffect: {
//       crossFade: true, // keep enabled for soft transition
//     },
//     loop: true,
//     speed: 700, // shorter fade duration
//     autoplay: {
//       delay: 2000, // longer time before next transition
//       disableOnInteraction: false,
//     },
//   });


// Initialize Swiper
  initNearView(document.querySelector('.swiper-expectation'), function () {
  const swiperExpectation = new Swiper('.swiper-expectation', {
      slidesPerView: 1.5,
      spaceBetween: 23,
      loop: false,
      speed: 1000, // ← smoothness in ms (try 600–1000)
      breakpoints: {
          768: {
              slidesPerView: 3,
              spaceBetween: 46,
          }
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
  });

  // Get all nav items
  const navItems = document.querySelectorAll('.expection-nav div');

  // Function to update active class
  function updateNavActive(index) {
      navItems.forEach(item => item.classList.remove('active'));
      const navItem = document.querySelector(`.expection-nav div[data-index="${index}"]`);
      if(navItem) navItem.classList.add('active');
  }

  // Initial active class
  updateNavActive(swiperExpectation.activeIndex);

  // Listen to Swiper slide change
  swiperExpectation.on('slideChange', () => {
      updateNavActive(swiperExpectation.activeIndex);
  });

  // Optional: click nav to slide Swiper
  navItems.forEach(item => {
      item.addEventListener('click', () => {
          const index = parseInt(item.dataset.index);
          swiperExpectation.slideTo(index);
      });
  });
  });



  initNearView(document.querySelector('.swiper-vertical-onefit-in-store'), function () {
  var storeSwiper = new Swiper(".swiper-vertical-onefit-in-store", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 1200, // fade duration
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
     // ✅ autoplay config
  autoplay: {
    delay: 3000,           // fade every 3 seconds
    disableOnInteraction: false // never stop on user interaction
  },
    allowTouchMove: true,
    observer: true,
    observeParents: true
  });
  });

  

 
});
